// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import AuditPreparation from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import {FormattedMessage} from 'react-intl';
import PrepareAuditListItem from '../../../shared/components/prepare-audit-list-item';
import {buildNumber} from '../../../../shared/services/build-number';

function handleSelectNewClaimsModalOpen() {

    this.actions.updateSystemSelectedClaimsModalVisibility(true);

}

const SystemSelectedClaimsAccordion = props => {

    const systemSelectedClaims = props.auditPreparation.claims.filter(claim =>
        claim.isSystemSelected
    );

    const body = systemSelectedClaims.map(item =>
        <PrepareAuditListItem
            item={item}
            key={item.claimNumber}
        />
    );

    const title = (
        <div className='system-selected-claims-accordion-title'>
            <FormattedMessage
                id='SYSTEM_SELECTED_CLAIMS_WITH_COUNT'
                values={{
                    count: buildNumber(systemSelectedClaims.length)
                }}
            />
        </div>
    );

    const selectNewClaimsModalLink = (
        <div
            className='select-new-claims-modal-link'
            onClick={props::handleSelectNewClaimsModalOpen}
        >
            <FormattedMessage id='SELECT_NEW_CLAIMS'/>
        </div>
    );

    return (
        <div>
            <Accordion
                accordionId='system-selected-claims-accordion'
                body={body}
                secondaryHeaderNode={selectNewClaimsModalLink}
                title={title}
            />
        </div>
    );

};

SystemSelectedClaimsAccordion.displayName = 'SystemSelectedClaimsAccordion';
SystemSelectedClaimsAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    auditPreparation: PropTypes.instanceOf(AuditPreparation).isRequired
};

export default SystemSelectedClaimsAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/system-selected-claims-accordion/system-selected-claims-accordion.js